var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { StageDependantCrudService } from '../interfaces';
var AlbumService = /** @class */ (function (_super) {
    __extends(AlbumService, _super);
    function AlbumService(http, authService) {
        return _super.call(this, http, '/albums', authService) || this;
    }
    return AlbumService;
}(StageDependantCrudService));
export { AlbumService };
